import { kebabCase } from "../../utils/change-case"

export const BLOG_CATEGORY_PATH = "/blog/category/"
export const BLOG_SEARCH_PATH = "/blog/search/"

export const getBlogCategoryPath = (
  category?: string,
  pageNumber?: number,
  searchQuery?: string,
  categoryFilter?: string,
) => {
  const basePath = category
    ? `${BLOG_CATEGORY_PATH}${kebabCase(category)}/`
    : BLOG_SEARCH_PATH
  const urlQueryParams = new URLSearchParams()
  if (searchQuery) {
    urlQueryParams.set("searchQuery", searchQuery)
  }
  if (pageNumber) {
    urlQueryParams.set("page", pageNumber.toString())
  }
  if (categoryFilter) {
    urlQueryParams.set("category", categoryFilter)
  }
  const stringifiedParams = urlQueryParams.toString()
  const paramsWithSeparator = stringifiedParams ? `?${stringifiedParams}` : ""
  return `${basePath}${paramsWithSeparator}`
}

export const getBlogSearchPath = (searchQuery?: string) =>
  getBlogCategoryPath(undefined, undefined, searchQuery)
